import React from "react";
import withSideEffect from "react-side-effect";

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.href;
  }
  return undefined;
}

var originalHref;

function handleStateChangeOnClient(href) {
  var link = document.head.querySelector("link[rel=icon]");
  if (!originalHref) {
    originalHref = link.href;
  }
  link.href = href || originalHref;
}

function Favicon({ children }) {
  if (children) {
    return React.Children.only(children);
  } else {
    return null;
  }
}

export default withSideEffect(reducePropsToState, handleStateChangeOnClient)(Favicon);
